import React, { Component, ReactNode } from 'react'
import { ErrorPageNotFound } from '../pageNotFound'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorPageNotFound />
    }

    return this.props.children
  }
}

export default ErrorBoundary
